import { useKeycloak } from "providers/KeycloakProvider";

export const useGetUser = () => {
  const keycloakUserData = useKeycloak();
  return {userProfile: keycloakUserData.userProfile, userGroups: keycloakUserData.userGroups};
};
